import i18n from 'modules/core/lib/i18n'

export const enum SelectedSurvey {
  Enps = 1,
  Climate,
  Both,
}

enum Colours {
  red = 'red',
  yellow = 'yellow',
  green = 'green',
}

export type ColoursTypes = keyof typeof Colours

export const getClimateScoreDescription = (score: number) => {
  const roundScore = Math.round(score)

  if (roundScore >= 1 && roundScore <= 3)
    return i18n.t('engagement_insights.climate_widget.analytics.score.unhappy')
  if (roundScore >= 4 && roundScore <= 5)
    return i18n.t('engagement_insights.climate_widget.analytics.score.dissatisfied')
  if (roundScore >= 6 && roundScore <= 7)
    return i18n.t('engagement_insights.climate_widget.analytics.score.engaged')
  if (roundScore >= 8 && roundScore <= 9)
    return i18n.t('engagement_insights.climate_widget.analytics.score.happy')
  return i18n.t('engagement_insights.climate_widget.analytics.score.highly_engaged')
}

export const getEnpsWidgetEllipseColor = (score: number) => {
  if (score <= -1) return Colours.red
  if (score >= 0 && score <= 10) return Colours.yellow
  if (score >= 11) return Colours.green
}

export const getClimateWidgetEllipseColor = (score: number) => {
  const roundScore = Math.round(score)

  if (roundScore >= 1 && roundScore <= 5) return Colours.red
  if (roundScore >= 6 && roundScore <= 7) return Colours.yellow
  if (roundScore >= 8 && roundScore <= 10) return Colours.green
}
